/**
 * @generated SignedSource<<9e36da1ea645220731b0534be3dedc82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
import { FragmentRefs } from "relay-runtime";
export type TodoEditMoveToCategorySelector_todoCategories$data = ReadonlyArray<{
  readonly icon: TodoCategoryIcon | null;
  readonly id: string;
  readonly isDefault: boolean;
  readonly title: string;
  readonly " $fragmentType": "TodoEditMoveToCategorySelector_todoCategories";
}>;
export type TodoEditMoveToCategorySelector_todoCategories$key = ReadonlyArray<{
  readonly " $data"?: TodoEditMoveToCategorySelector_todoCategories$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditMoveToCategorySelector_todoCategories">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TodoEditMoveToCategorySelector_todoCategories",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    }
  ],
  "type": "TodoCategory",
  "abstractKey": null
};

(node as any).hash = "c23778d33702c7a72fe401ef48978381";

export default node;
